var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdificio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 23.25H0.5V20.75H1.75V2C1.75 1.66848 1.8817 1.35054 2.11612 1.11612C2.35054 0.881696 2.66848 0.75 3 0.75H20.5C20.8315 0.75 21.1495 0.881696 21.3839 1.11612C21.6183 1.35054 21.75 1.66848 21.75 2V8.25H24.25V20.75H25.5V23.25ZM19.25 20.75H21.75V10.75H14.25V20.75H16.75V13.25H19.25V20.75ZM19.25 8.25V3.25H4.25V20.75H11.75V8.25H19.25ZM6.75 10.75H9.25V13.25H6.75V10.75ZM6.75 15.75H9.25V18.25H6.75V15.75ZM6.75 5.75H9.25V8.25H6.75V5.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificio);
export default __webpack_public_path__ + "static/media/edificio.146e8f473b03966e5fe872163a7aa4b5.svg";
export { ForwardRef as ReactComponent };